import Vue from 'vue'
import Vuex from 'vuex'
import storejs from 'storejs'
import rate from './rate'
import user from './user'
import hotel from './hotel'
import flight from './flight'
import moment from 'moment'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        rate,
        user,
        hotel,
        flight
    },
    getters: {
        flight: state => state.rate.flight,
        sessionId: state => state.flight.sessionId,
        flightHotCitys: state => state.flight.hotCitys,
        flightSearchHistory: state => state.flight.searchHistory,
        hotel: state => state.rate.hotel,
        unit: state => state.rate.unit,
        price: state => state.rate.price,
        token: state => state.user.token,
        hotList: state => state.user.hotList,
        historyCityList: state => state.user.historyCityList,
        showLogin: state => state.user.showLogin,
        avatar: state => state.user.avatar,
        forgetFlow: state => state.user.forgetFlow,
        showSignup: state => state.user.showSignup,
        countryList: state => state.user.countryList,
        area: state => state.user.country,
        country: state => {
            return {
                name: state.user.country.short_name,
                code: state.user.country.code,
                allName: state.user.country.name,
                id: state.user.country.country_id
            }
        },
        showCountry: state => state.user.showCountry,
        nextRoute: state => state.user.nextRoute,
        user: state => state.user.user,
        guests: state => state.hotel.guests,
        hotelDes: state => state.hotel.destination,
        hotelDater: state => {
            let dater = state.hotel.dater;
            let startDate = moment(dater.startDate)
            let endDate = moment(dater.endDate)
            let dur = endDate.diff(startDate, 'days');
            dater.dur = dur;
            dater.startTime = startDate.unix();
            dater.endTime = endDate.unix();
            return dater;
        }
    },
    state: {
        unit: storejs('unit') || 'USD'
    },
    mutations: {
        setUnit(state, data) {
            state.unit = data;
        }
    },
});


// WEBPACK FOOTER //
// ./src/store/index.js